/* eslint-disable import/prefer-default-export */
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    btnSub: {
        background: '#39E4B8',
        color: '#fff',
        '&:hover': {
            background: '#30D3AA'
        }
    },
    btnSubTwo: {
        background: '#9B51E0',
        color: '#fff',
        '&:hover': {
            background: '#8A4BC6'
        }
    },

    inkBarStyle: {
        backgroundColor: '#39E4B8'
    },

    inkBarStyleTwo: {
        backgroundColor: '#9B51E0'
    }
});
